export const HIDE_INVOICE_STATUS_RETAILERS = ['59'];

export const shouldHideInvoiceStatus = (
  retailerId: string | undefined,
): boolean => !!retailerId && HIDE_INVOICE_STATUS_RETAILERS.includes(retailerId);
